export default "assets/images/icons/entity-date-9f96b65a.svg";